export enum ContentProviderType {
  Yodeck = "Yodeck"
}
